<template>
  <div class="log">
    <Steps :timeline-list="logData.handlers">
      <div
        v-for="(i, index) in logData.handlers"
        style="display: inline-block"
        :key="index"
        :slot="'header' + index"
      >
        <span class="handleUserName">{{ i.userName }}</span>
        <span class="alarmType">【{{ i.handleTypeName }}】</span>
        <span v-if="i.assignNames" class="handleUserName">{{ i.assignNames }}</span>
        <span class="centerName">{{ i.areaName }}</span>
      </div>
      <div
        v-for="(i, index) in logData.handlers"
        style="display: inline-block"
        :key="index"
        :slot="'content' + index"
      >
        <div class="content">
          <div class="item-m">
            <span>时间:</span><span>{{ i.createGmt }}</span>
          </div>
          <div class="item-m">
            <span>地点:</span><span>{{ i.areaName }}</span>
          </div>
          <div class="item-m">
            <span>内容:</span><span>{{ i.content ? i.content : "暂无内容" }}</span>
          </div>
          <div class="item-m" v-if="i.clueFiles.length != 0">
            <span>图片:</span>
            <div class="img">
              <div v-for="(item, index) in i.clueFiles" :key="index">
                <el-image
                  v-if="item.fileType == 1"
                  style="width: 100px; height: 100px"
                  :src="item.fileUrl"
                  :preview-src-list="[item.fileUrl]"
                ></el-image>
              </div>
            </div>
          </div>
          <div class="item-m" v-if="i.clueFiles.length != 0">
            <span>音频:</span>
            <div class="img" v-for="(item, index) in i.clueFiles" :key="index">
              <m-audio v-if="item.fileType == 4" :src="item.fileUrl"></m-audio>
            </div>
          </div>

          <div v-for="(item, index) in i.disTask" :key="index" style="margin-top: 10px">
            <p>
              <span class="handleUserName">{{ item.name }}</span
              ><span class="alarmType">【{{ item.statusName }}】</span>
            </p>
            <p>
              <span>紧急程度: </span><span>{{ item.grad }}</span>
            </p>
            <div class="disTask">
            <span class="task-title">任务反馈</span>
            <div class="item-m">
                <span>内容：</span>
                <span>{{item.resultContent}}</span>
            </div>
            <div class="item-m" v-if="item.files.length != 0">
              <span>图片：</span>
              <div class="img">
                <div v-for="(citem, cindex) in item.files" :key="cindex">
                  <el-image
                    v-if="citem.fileType == 1"
                    style="width: 100px; height: 100px"
                    :src="citem.fileUrl"
                    :preview-src-list="[citem.fileUrl]"
                  ></el-image>
                </div>
              </div>
            </div>
            <div class="item-m" v-if="item.files.length != 0">
              <span>音频：</span>
              <div class="img" v-for="(citem, cindex) in item.files" :key="cindex">
                <m-audio v-if="citem.fileType == 4" :src="citem.fileUrl"></m-audio>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </Steps>
  </div>
</template>

<script>
import { listAPI } from "@/api-path/command-center.js";
export default {
  name: "log",
  data() {
    return {
      alarmId: {},
      logData: [
        {
          isOpen: false,
          handleType: "1",
          centerName: "浆洗街街道",
          content: null,
          address: "四川省成都市武侯区萃华路88号靠近亚朵酒店(成都高新店)",
          handleDate: "2020-09-27 13:45:53",
          handleUserName: "张靖宇",
          id: "70287db8-c6a9-4b8d-9cfb-5354892f156a",
          createGmt: "2020-09-27T13:45:53.000+0800",
          handleTypeName: "发起报警",
          alarmRemarkLogVo: {
            id: null,
            content: null,
            resultContent: null,
            fileUrls: null,
            imageUrls: null,
            voiceUrls: null,
            alarmGradeId: null,
            alarmGradeName: null,
            processTime: "2020-09-27 13:45:53",
            fileForAddClueVos: null,
          },
          alarmHandlerTaskNodeList: null,
          alarmType: "一键报警",
          longitude: 104.066387,
          latitude: 30.544757,
          devicePerson: null,
        },
        {
          isOpen: false,
          handleType: "1",
          centerName: "浆洗街街道",
          content: null,
          address: "四川省成都市武侯区萃华路88号靠近亚朵酒店(成都高新店)",
          handleDate: "2020-09-27 13:45:53",
          handleUserName: "张靖宇",
          id: "70287db8-c6a9-4b8d-9cfb-5354892f156a",
          createGmt: "2020-09-27T13:45:53.000+0800",
          handleTypeName: "发起报警",
          alarmRemarkLogVo: {
            id: null,
            content: null,
            resultContent: null,
            fileUrls: null,
            imageUrls: null,
            voiceUrls: null,
            alarmGradeId: null,
            alarmGradeName: null,
            processTime: "2020-09-27 13:45:53",
            fileForAddClueVos: null,
          },
          alarmHandlerTaskNodeList: null,
          alarmType: "一键报警",
          longitude: 104.066387,
          latitude: 30.544757,
          devicePerson: null,
        },
        {
          isOpen: false,
          handleType: "4",
          centerName: "中国",
          content: null,
          address: "四川省成都市武侯区萃华路88号靠近亚朵酒店(成都高新店)",
          handleDate: "2020-09-27 13:46:01",
          handleUserName: "超级管理员2",
          id: "68237508-91d9-4cbc-8922-71835a3a43e7",
          createGmt: "2020-09-27T13:45:59.000+0800",
          handleTypeName: "接警",
          alarmRemarkLogVo: null,
          alarmHandlerTaskNodeList: null,
          alarmType: "一键报警",
          longitude: 104.066387,
          latitude: 30.544757,
          devicePerson: null,
        },
      ],
    };
  },
  created() {
    this.alarmId = this.$store.state.alarmId || sessionStorage.getItem("groupId");
    this.getAlarmDetail();
  },
  methods: {
    getAlarmDetail() {
      this.$http.get(listAPI.datail + "?alarmId=" + this.alarmId).then((res) => {
        if (res.status === 200) {
          res.result.handlers.map((item) => {
            item.isOpen = false;
          });
          this.logData = res.result;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "log";
.disTask{
    display: flex;
    flex-direction: column;
    .task-title{
        margin-top: 10px;
    }
    .item-m{
        display: flex;
        margin-bottom: 10px;
        span{
            // margin-right: 5px;
        }
        .img{
            display: flex;
            flex-wrap: wrap;
            .el-image{
                margin: 0 5px;
            }
        }
    }
}
</style>
